// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"8786":"cd89f676","8831":"a74be65b"}[chunkId] + ".css";
};